export const getUsersCount = async (eventId) => {
  if (eventId) {
    const response = await fetch(process.env.REACT_APP_TENCENT_PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'getUsersCount', roomId: eventId }),
    })
    if (!response.ok) {
      return { count: 0 }
    }
    const parsedResponse = await response.json()
    return parsedResponse
  }
  return { count: 0 }
}
